import { registerPlugin } from '@capacitor/core';
const CapacitorPluginRecaptcha = registerPlugin('RecaptchaEnterprise', {
    web: () => import('./web').then((m) => new m.CapacitorPluginRecaptcha()),
});
export * from './definitions';
export { CapacitorPluginRecaptcha };
//# sourceMappingURL=index.js.map